import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M18 9v4H6V9H4v6h16V9z"
}), 'SpaceBar');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SpaceBar.js
// module id = 6328
// module chunks = 2